import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = [
    "teamSelect",
    "typeSelect",
    "csFields",
    "freeShippingCouponFields",
    "generalCouponFields",
    "orderValueCouponFields",
    "firstTimeCustomerCouponFields",
    "storeCouponFields",
    "productSpecificCouponFields",
    "thankyouUpsellCouponFields",
    "couponCodeContainer",
    "couponCodeForm",
    "singleCouponFields",
    "multipleCouponFields",
    "redemptionsInput"
  ];

  connect() {
    this.toggleCSFields()
    this.toggleFreeShippingCouponFields()
    this.toggleGeneralCouponFields()
    this.toggleOrderValueCouponFields()
    this.toggleFirstTimeCustomerCouponFields()
    this.toggleStoreCouponFields()
    this.toggleProductSpecificCouponFields()
    this.toggleThankyouUpsellCouponFields()
    this.toggleCouponCodeForm()
  }

  updateTeam() {
    this.toggleCSFields()
  }

  updateType() {
    this.toggleCSFields()
    this.toggleFreeShippingCouponFields()
    this.toggleGeneralCouponFields()
    this.toggleOrderValueCouponFields()
    this.toggleFirstTimeCustomerCouponFields()
    this.toggleStoreCouponFields()
    this.toggleProductSpecificCouponFields()
    this.toggleThankyouUpsellCouponFields()
    this.toggleCouponCodeForm({ target: { value: 'single' } });
  }

  toggleCSFields() {
    const team = this.teamSelectTarget.value
    const type = this.typeSelectTarget.value
    const show = type === "Coupons::AccountCreationCoupon" || (type === "Coupons::GeneralCoupon" && team === "CS")

    this.csFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        if (input.id !== "coupon_apply_on_inclusive_total") input.disabled = !show
      })
    })
  }

  toggleFreeShippingCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::FreeShippingCoupon")

    this.freeShippingCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })
  }

  toggleGeneralCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::GeneralCoupon" || type === "Coupons::AccountCreationCoupon")

    this.generalCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })
  }

  toggleOrderValueCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::BasketValueCoupon" || type === "Coupons::AccountCreationCoupon")

    this.orderValueCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })
  }

  toggleFirstTimeCustomerCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::FirstTimeCustomerCoupon")

    this.firstTimeCustomerCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })
  }

  toggleStoreCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::ArtistStoreCoupon")

    this.storeCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })
  }

  toggleProductSpecificCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::ProductSpecificCoupon")

    this.productSpecificCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })
  }

  toggleThankyouUpsellCouponFields() {
    const type = this.typeSelectTarget.value
    const show = (type === "Coupons::ThankyouUpsellCoupon")

    this.thankyouUpsellCouponFieldsTargets.forEach(el => {
      el.classList.toggle("hidden", !show)
      el.querySelectorAll('input, select, textarea').forEach(input => {
        input.disabled = !show
      })
    })

    if (this.hasCouponCodeContainerTarget) {
      this.couponCodeContainerTarget.classList.toggle("hidden", show)
      this.couponCodeContainerTarget.querySelectorAll('input, select, textarea').forEach(input => {
        if (show) {
          input.dataset.wasDisabled = input.disabled
          input.disabled = true
        } else if ('wasDisabled' in input.dataset) {
          input.disabled = input.dataset.wasDisabled === 'true'
        }
      })
    }
  }

  toggleCouponCodeForm(event) {
    const selectedValue = event.target.value || 'single';
    const singleCouponFields = this.singleCouponFieldsTarget;
    const multipleCouponFields = this.multipleCouponFieldsTarget;

    singleCouponFields.classList.toggle("hidden", selectedValue !== "single");
    multipleCouponFields.classList.toggle("hidden", selectedValue !== "multiple");
  }

  toggleRedemptionsInput(event) {
    const redemptionsInput = this.redemptionsInputTarget;
    redemptionsInput.disabled = event.target.checked;
    if (event.target.checked) {
      redemptionsInput.value = "";
    }
  }
}
